import { render } from "./bkDashboard.vue?vue&type=template&id=4716d83c&scoped=true"
import script from "./bkDashboard.vue?vue&type=script&lang=js"
export * from "./bkDashboard.vue?vue&type=script&lang=js"

import "./bkDashboard.vue?vue&type=style&index=0&id=4716d83c&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4716d83c"]])

export default __exports__